import { render } from "./DAToolbar.vue?vue&type=template&id=b7f8662e&scoped=true"
import script from "./DAToolbar.vue?vue&type=script&lang=js"
export * from "./DAToolbar.vue?vue&type=script&lang=js"

import "./DAToolbar.vue?vue&type=style&index=0&id=b7f8662e&lang=scss&scoped=true"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7f8662e"]])

export default __exports__